export default "__VITE_ASSET__CBmzAXQs__"